"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SensitiveTopicFilterToJSON = exports.SensitiveTopicFilterFromJSONTyped = exports.SensitiveTopicFilterFromJSON = exports.SensitiveTopicFilter = void 0;
/**
 * How restrictive the ads system should be when considering serving an ad on a particular
 * podcast episode based on the sensitive topics associated with the episode.
 * These filters can either be applied on a per topic basis or globally for all sensitive topics, but cannot be applied at both levels.
 *
 * @export
 */
exports.SensitiveTopicFilter = {
    Standard: 'STANDARD',
    Partial: 'PARTIAL',
    Limited: 'LIMITED',
    Restricted: 'RESTRICTED'
};
function SensitiveTopicFilterFromJSON(json) {
    return SensitiveTopicFilterFromJSONTyped(json, false);
}
exports.SensitiveTopicFilterFromJSON = SensitiveTopicFilterFromJSON;
function SensitiveTopicFilterFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.SensitiveTopicFilterFromJSONTyped = SensitiveTopicFilterFromJSONTyped;
function SensitiveTopicFilterToJSON(value) {
    return value;
}
exports.SensitiveTopicFilterToJSON = SensitiveTopicFilterToJSON;
